/**
 * `useContactsClient()` — constructs a `ContactsClient` bound to the
 * current workspace. The fetcher reads the workspace UUID from the auth
 * provider's workspace context (NEVER from a route param) so callers
 * can't accidentally cross workspaces.
 *
 * Per NFR-ISO-6: the fetcher binds `workspaceId` at construction; no
 * method accepts a workspace override.
 */

import { useWorkspace } from "@cometchat-ai/auth/client";
import { useMemo } from "react";

import { ContactsClient } from "./contacts-client";
import { makeWorkspaceFetcher } from "./workspace-fetcher";

function readApiBaseUrl(): string {
  const env = (import.meta as ImportMeta & { env?: Record<string, string | undefined> }).env;
  return (env?.VITE_API_BASE_URL ?? "").replace(/\/$/, "");
}

export function useContactsClient(): ContactsClient {
  const { workspace } = useWorkspace();
  return useMemo(
    () =>
      new ContactsClient(
        makeWorkspaceFetcher({
          workspaceId: workspace.id,
          apiBaseUrl: readApiBaseUrl(),
        }),
      ),
    [workspace.id],
  );
}
